export default __webpack_public_path__ + "static/media/team98.a9f8905a.JPG";